'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useInteractiveLoader } from '~/components/PartnerLoader/PartnerLoader';
import { useToast } from '~/hooks/useToasts';
import { useUpdateTrip } from '~/hooks/useUpdateTrip';
import { trackFunnelEvent } from '~/utils/funnelTracking';
import { useTripOverviewSummary } from './useTripOverviewSummary';
export const useTripOriginUpdate = () => {
  const {
    originCity
  } = useTripOverviewSummary();
  const toast = useToast();
  const tFeedback = useTranslations('content.feedback');
  const updateTrip = useUpdateTrip();
  const {
    startLoader,
    completeProgressBar
  } = useInteractiveLoader();
  const [localOrigin, setLocalOrigin] = useState<string | null>(null);
  const confirmedOrigin = localOrigin ?? originCity;
  const confirmOrigin = async (locationName: string): Promise<boolean> => {
    startLoader();
    try {
      const result = await updateTrip({
        closest_city: locationName
      });
      if (result.error) {
        toast?.add({
          title: result.error,
          variant: 'error',
          position: 'middle'
        }, {
          timeout: 5000
        });
        return false;
      }
      if (result.customerInfoMessages?.includes('DEPARTURE_DATE_CHANGED_FOR_ORIGIN')) {
        toast?.add({
          title: tFeedback('origin_change_date_earlier'),
          variant: 'info',
          position: 'middle'
        });
      }
      setLocalOrigin(locationName);
      trackFunnelEvent('trip_funnel_origin_selected', {
        origin: locationName
      });
      return true;
    } finally {
      completeProgressBar();
    }
  };
  return {
    confirmedOrigin,
    confirmOrigin
  };
};